import { useContext, useEffect } from "react";
import thousandSeparator from "../../../utils/ThousandSeparator";
import { defaultColumnColors } from "../EmissoraColor/EmissoraColor";
import { UiContext } from "../../../context/UiContext";

export function MediaGraphicLine({ heading, lastAudience, data, divMinute, audienceMediaFirstTable }) {
  const {
    isMobile,
    hasShortHeightDetail,
    mediaHeaderWidthAbsolute,
    mediaHeaderWidth2Absolute,
    channelsLength, calculateEmissorasColumn } = useContext(UiContext);
  const getChartLineHeight = () => {
    let chartHeight = 240;
    let chartPercentWindowMobile = 44.15;
    let deviceRatio = window.devicePixelRatio > 1 ? 1.25 : 1;
    if (hasShortHeightDetail) {
      if (window.innerHeight <= 320) {
        return 0;
      }
      if (window.innerHeight <= 400) {
        return window.innerHeight * (chartPercentWindowMobile * deviceRatio) / 100 - chartTopPadding - tableTitleHeight;
      }
    }
    return chartHeight + (chartHeight * deviceRatio / 100);
  };
  const RootComponent = document.getElementById("root");
  const pUiScreenWidth = parseFloat(RootComponent ? getComputedStyle(RootComponent).width : '0');
  const pColumnsCustomColors = heading?.enabled.map(x => x.color);

  let columnColors = pColumnsCustomColors ?? defaultColumnColors;
  let menu = document.getElementsByClassName("menu")[0];
  let divDate = document.getElementsByClassName("divDate")[0];
  let tableTitleHeight = parseFloat(divDate !== undefined ? getComputedStyle(divDate).height : '0');
  if (hasShortHeightDetail) { tableTitleHeight += 40 }
  let chartTopPadding = parseFloat(menu !== undefined ? getComputedStyle(menu).height : '0');


  let emissoraWidth = calculateEmissorasColumn(heading?.enabled);
  let tableColumnWidth = emissoraWidth;

  const chartHeight = getChartLineHeight();

  let GridAudienceColumn = document.getElementsByClassName("Media_cellRows")[0];
  let chartWidth = parseFloat(GridAudienceColumn !== undefined ? getComputedStyle(GridAudienceColumn).width : tableColumnWidth + "") - 0.2;

  function parseData(valueString) {
    const values = valueString ? valueString.split('|') : ['', ''];
    const parsedValues = values.map(value => parseFloat(values[0]));
    return [
      isNaN(parsedValues[0]) ? 0 : parsedValues[0],
      isNaN(parsedValues[1]) ? 0 : parsedValues[1]
    ];
  }
  let isMerged = true;

  let emptyCell = (
    <td key="first" style={{
      verticalAlign: "bottom",
      padding: "0px",
      height: `${chartHeight}px`,
      width: `${mediaHeaderWidthAbsolute}px`,
      position: "relative",
      minWidth: `${mediaHeaderWidthAbsolute}px`,
    }}></td>
  );
  let lineChartLength = 30;

  let firstRowCells = data[0] ? data[0] : [];

  let columns = firstRowCells.length > 0 ? firstRowCells.map(() => []) : [];
  let lineChartWidth = chartWidth;
  let maxValue = 0;
  data.forEach((row, rowIndex) => {
    if (rowIndex >= lineChartLength) {
      return;
    }
    row.forEach((cell, index) => {
      let value = parseData(cell)[0];
      if (Array.isArray(columns[index])) {
        columns[index].push(value);
      } else {
        console.warn('some rows have more columns than expected');
      }
      maxValue = Math.max(maxValue, value);
    });
  });
  let textData = [],
    dataObj: any = [];

  firstRowCells.forEach(function (cellValue) {
    dataObj.push(parseData(cellValue));
  });

  let maxPixelValue = chartHeight - chartTopPadding - tableTitleHeight;
  let pieSum = 0;
  let lastPiePieceValue = 100;

  let row = (
    <tr
    >
      {emptyCell}
      {heading.enabled.map((column, key) => {
        let backgroundColor = columnColors[(key % columnColors.length)];
        let values = dataObj[key] ?? [0, 0];
        let valuePercent = maxValue > 0 ? values[0] / maxValue : 0;
        pieSum += values[0] < 100 ? values[0] : 0;
        lastPiePieceValue -= values[0] === 100 ? 0 : values[0];

        let valuePixels = maxValue === 0 ? 10 : Math.ceil(valuePercent * maxPixelValue);
        let textValues = firstRowCells[key] ? firstRowCells[key].split('|') : ['', ''];

        let lineChartHeight = maxPixelValue;
        let dataHistory = columns[key];
        let svgLine: any = null;
        let lineDot: any = null;
        let mainTextValue: any = null;
        let secondaryTextValue: any = null;

        if (
          dataHistory !== undefined &&
          maxValue > 0
          // !(p.rows.type === 'merged' && p.user.autoUpdate === true)
        ) {
          let linePath = '';
          dataHistory.forEach((value, rowIndex) => {
            if (
              (rowIndex === 0 && isMerged) ||

              (parseInt(audienceMediaFirstTable[rowIndex][2]) === 0)
            ) {
              return null;
            }
            let startIndex = isMerged ? 1 : 0;
            let pX = 1 - ((rowIndex - startIndex) / (dataHistory.length - 1 - startIndex));
            let x = Math.round(pX * lineChartWidth);
            let pY = value / maxValue;
            let y = Math.round((lineChartHeight - 2) - pY * (lineChartHeight - 2)) + 1;
            linePath += `L${x},${y} `;
          });
          linePath = linePath.length > 1 ? 'M' + linePath.substring(1) : '';
          const yValueString = linePath.split(",")[1];
          const yValue = yValueString ? parseInt(yValueString.trim()) : 0;
          let dotBottom = linePath === '' ? lineChartHeight - (Math.round((lineChartHeight - 2) - (dataHistory[0] / maxValue) * (lineChartHeight - 2)) + 1) : maxPixelValue - yValue - 2;

          svgLine = (
            <svg
              width={lineChartWidth - 1}
              height={lineChartHeight}
              style={{
                position: 'absolute',
                shapeRendering: 'crispEdges',
                bottom: 0,
              }}
            >
              <path
                d={linePath}
                stroke={'white'}
                strokeWidth={1}
                fill={'none'}
              >
              </path>
            </svg>
          );
          lineDot = (
            <div
              style={{
                display: 'block',
                width: 5,
                height: 5,
                position: 'absolute',
                backgroundColor: '#FFFFFF',
                borderRadius: 5,
                bottom: dotBottom,
                right: - 2,
                zIndex: 1
              }}
            ></div>
          );
        }

        mainTextValue = (
          <p
            className="valueChart"
            style={{
              position: 'absolute',
              right: 10,
              top: 0,
              textAlign: 'right',
              fontSize: 17,
              marginTop: - (10 + 17),
              color: '#FFFFFF'
            }}
          >
            {thousandSeparator.formatWithSeparator(textValues[0])}
          </p>
        );
        secondaryTextValue = (
          <p
            style={{
              position: 'absolute',
              right: 10,
              top: 0,
              textAlign: 'right',
              fontSize: 12,
              marginTop: - (28 + 12),
              color: '#FFFFFF',
              opacity: 0.5
            }}
          >
            {((values[1] > 0) && (textValues[1] !== '-')) ?
              textValues[1] + '%' : ''}
          </p>
        );

        return (
          <td key={key} style={{
            position: 'relative',
            verticalAlign: 'bottom',
            width: chartWidth,
            minWidth: chartWidth
          }}>
            <div
              style={{
                backgroundColor: backgroundColor,
                position: 'relative',
                bottom: 0,
                width: '100%',
                height: valuePixels
              }}
            >
              {mainTextValue}
              {secondaryTextValue}
              {svgLine}
              {lineDot}
            </div>
          </td>
        );
      })}
    </tr>
  );

  const contentGraphic = (
    <div
      id="column-bars"
      style={{
        width: pUiScreenWidth
      }}
    >
      <table style={{ marginLeft: 1 }}>
        <tbody>

          {row}
        </tbody>
      </table>
    </div>
  );

  return (
    <div
      id="chartLine"
      data-testid="chartLine"
      style={{
        height: getChartLineHeight(),
        overflow: "hidden",
        marginRight: "1%",
        display: "flex"
      }}
    >
      {contentGraphic}
    </div>
  );
}
